import React from 'react';

export const ArrowLeftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
      <path
        d="M2.55207 4L5.60927 0.942809L4.66646 0L0 4.66646L4.66646 9.33291L5.60927 8.3901L2.5525 5.33333H14V4H2.55207Z"
        fill="#3659E3"
      />
    </svg>
  );
};
